import { SUBTRAMITES_CONFIG } from "./constants";
import { SubtramiteKey } from "./types";

export const getSubtramiteConfig = (key: SubtramiteKey): (typeof SUBTRAMITES_CONFIG)[SubtramiteKey] => {
  const config = SUBTRAMITES_CONFIG[key];
  if (!config) {
    throw new Error(`Subtramite with key ${key} does not exist`);
  }
  return config;
}

export type SubtramiteConfig = ReturnType<typeof getSubtramiteConfig>;
